import React from 'react';
import ReactDOM from 'react-dom';
import { Routes, Route, Navigate } from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './css/walmates.css';

import App from './app';
import Walmates from './walmates';
import Login from './login';
import Titan from './titan/titan';
import MusicApp from './music/music_app';
import SimilarTracksPage from './music/similar_tracks_page';
import MusicShell from './music/music_shell';

import Vault from './vault/vault';

import Todo from './todo/todo';

function RequireAuth({ children }) {
  const token = localStorage.getItem('walmates-token');
  const userId = localStorage.getItem('walmates-user_id');
  if (!token || !userId) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

ReactDOM.render(
  <Router>
    <Routes>
      <Route exact path="/" element={<App />} />
      <Route exact path="/home" element={<RequireAuth><Walmates /></RequireAuth>} />
      <Route exact path="/login" element={<Login />} />
      <Route exact path="/titan" element={<RequireAuth><Titan /></RequireAuth>} />
      <Route element={<MusicShell />}>
        <Route exact path="/music" element={<MusicApp />} />
        <Route path="/music/similar" element={<SimilarTracksPage />} />
        <Route exact path="/vault" element={<Vault />} />
        <Route exact path="/todo" element={<Todo />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>,
  document.getElementById('root')
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => console.log('✅ Service Worker registered:', reg.scope))
      .catch(err => console.error('❌ Service Worker registration failed:', err));
  });
}
